import { faYoutube, faInstagram, faTiktok, faXTwitter, faReddit } from "@fortawesome/free-brands-svg-icons";

// Orden fijo de colores por red social (validado para daltonismo sobre el fondo oscuro).
export const PLATFORMS = {
    youtube: { label: "YouTube", color: "#3987e5", icon: faYoutube },
    instagram: { label: "Instagram", color: "#d95926", icon: faInstagram },
    tiktok: { label: "TikTok", color: "#199e70", icon: faTiktok },
    twitter: { label: "X / Twitter", color: "#c98500", icon: faXTwitter },
    reddit: { label: "Reddit", color: "#d55181", icon: faReddit },
};

export const CONNECTABLE_PLATFORMS = ["youtube", "instagram", "tiktok"];

// Mismos tres primeros colores para las series de usuarios.
export const SERIES_COLORS = ["#3987e5", "#d95926", "#199e70"];

export const ACCOUNT_STATUS = {
    active: { label: "Conectada", tone: "good" },
    reauth_required: { label: "Requiere reconexión", tone: "warning" },
    disconnected: { label: "Desconectada", tone: "critical" },
};

const numberFormat = new Intl.NumberFormat("es-CO", { maximumFractionDigits: 1 });
const compactFormat = new Intl.NumberFormat("es-CO", { notation: "compact", maximumFractionDigits: 1 });

export const formatNumber = (value) => (value === null || value === undefined ? "—" : numberFormat.format(value));
export const formatCompact = (value) => (value === null || value === undefined ? "—" : compactFormat.format(value));
export const formatPercent = (value) => (value === null || value === undefined ? "—" : `${numberFormat.format(value)}%`);

export const formatDateTime = (value) =>
    value
        ? new Date(value).toLocaleString("es-CO", { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })
        : "Nunca";

// 'YYYY-MM-DD' en UTC, que es como la API agrupa los días.
export const toDayKey = (date) => date.toISOString().slice(0, 10);

// Termina hoy para incluir los videos recién publicados. Los datos de Roblox
// llegan con ~1 día de retraso: el día de hoy simplemente queda sin datos de juego.
export const defaultRange = () => {
    const to = new Date();
    const from = new Date(to);
    from.setUTCDate(from.getUTCDate() - 29);
    return { from: toDayKey(from), to: toDayKey(to) };
};

export const sum = (values) => values.reduce((total, value) => total + (value || 0), 0);

export const average = (values) => {
    const valid = values.filter((value) => value !== null && value !== undefined);
    return valid.length ? sum(valid) / valid.length : null;
};
